import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

/** A validator to check if email fields match */
export const emailMatchValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const email = control.get('notificationEmail');
  const confirmEmail = control.get('confirmNotificationEmail');

  // Return null if controls haven't initialized yet
  if (!email || !confirmEmail) {
    return null;
  }

  // Only validate when both fields have values
  if (email.value && confirmEmail.value) {
    if (email.value !== confirmEmail.value) {
      // Don't merge with other errors, just set the new one
      confirmEmail.setErrors({ emailMismatch: true });
      return { emailMismatch: true };
    } else {
      // Need to handle the case where the error was previously set
      // but now the emails match - clear only the emailMismatch error
      const currentErrors = confirmEmail.errors;
      if (currentErrors && currentErrors['emailMismatch']) {
        // If this is the only error, clear all errors
        if (Object.keys(currentErrors).length === 1) {
          confirmEmail.setErrors(null);
        } else {
          // Otherwise remove just this error
          const newErrors = { ...currentErrors };
          delete newErrors['emailMismatch'];
          confirmEmail.setErrors(newErrors);
        }
      }
    }
  }

  return null;
};

@Directive({
  selector: '[appEmailMatch]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: EmailMatchValidatorDirective,
      multi: true,
    },
  ],
})
export class EmailMatchValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return emailMatchValidator(control);
  }
}
